export default __webpack_public_path__ + "static/media/instagram.8c022a6d.svg";